import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './styles/animations.css';
import Banner from './components/Banner';
import EventRecap from './components/EventRecap';
import Footer from './components/Footer';
import ConsumerVision2035 from './components/ConsumerVision2035';
import Atmosfera from './components/Atmosfera';

// Home page component (version post-evento)
const HomePage = () => (
  <>
    <Atmosfera />
    <Banner />
    <EventRecap />
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/consumer-vision-2035" element={<ConsumerVision2035 />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;